const defaultConf = {
  fontSize: 12,
  textBaseLine: "middle",
};

function createAdjustableCanvas(options = {}) {
  const conf = { ...defaultConf, ...options };
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  const fontFamily = '"Helvetica Neue", Helvetica, Arial, sans-serif';

  let width = 1;
  let height = 1;
  let pxr = window.devicePixelRatio || 1;

  function adjustCanvas() {
    pxr = window.devicePixelRatio || 1;
    canvas.style.position = "absolute";
    canvas.style.top = "0px";
    canvas.style.left = "0px";
    canvas.style.width = `${width}px`;
    canvas.style.height = `${height}px`;
    canvas.width = width * pxr;
    canvas.height = height * pxr;
    ctx.font = `${conf.fontSize * pxr}px ${fontFamily}`;
    ctx.textBaseline = conf.textBaseLine;
    clearCanvas();
  }

  function clearCanvas() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
  }

  function setDimensions(newWidth, newHeight) {
    if (newHeight === height && newWidth === width) return false;
    height = newHeight;
    width = newWidth;
    adjustCanvas();
    return true;
  }

  function getPxRatio() {
    return pxr;
  }

  function getCanvasEl() {
    return canvas;
  }

  function getCtx() {
    return ctx;
  }

  function fillText(txt, x0, y0) {
    ctx.fillText(txt, x0 * pxr, y0 * pxr);
  }

  function roundRect(x0, y0, w, h, r) {
    ctx.roundRect(x0 * pxr, y0 * pxr, w * pxr, h * pxr, r);
  }

  function getTxtWidth(txt) {
    return ctx.measureText(txt).width / pxr;
  }

  function drawTextRect({ txt, x, y, px, py, bg, fg, r }) {
    const { fontSize: f } = conf;
    const txtWidth = getTxtWidth(txt);
    const w = txtWidth + 2 * px;
    const h = f + 2 * py;
    ctx.strokeStyle = "rgba(1, 1, 1, 0.000001)";
    ctx.fillStyle = bg;
    ctx.beginPath();
    roundRect(x - px, y - h / 2, w, h, [r * pxr]);
    ctx.fill();
    ctx.fillStyle = fg;
    ctx.beginPath();
    fillText(txt, x, y);
    ctx.fill();
  }

  return {
    getCtx,
    getCanvasEl,
    getTxtWidth,
    drawTextRect,
    fillText,
    roundRect,
    getPxRatio,
    clearCanvas,
    setDimensions,
  };
}

export default createAdjustableCanvas;
